// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"379b50d3","181":"a6e71799","481":"5262147f","488":"5d0097e3","759":"ccc9bd1c","790":"284d055c","885":"1edf9e1e","918":"80e43916"}[chunkId] + ".chunk.js";
};